module.exports = __webpack_public_path__ + "static/media/photo-1518099074172-2e47ee6cfdc0.d38d4013.jpg";